export default {
  "content": "<g clip-path=\"url(#clip0_803_11755)\"><path d=\"M5.86 13.75c-.27 0-.54-.11-.72-.31l-2.86-3a.996.996 0 111.44-1.38l2.07 2.17 6.28-7.85c.34-.43.97-.5 1.41-.16.43.34.5.97.16 1.41l-6.99 8.75c-.18.23-.45.36-.74.38-.02-.01-.04-.01-.05-.01z\" fill=\"#21944E\"/></g><defs><clipPath id=\"clip0_803_11755\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};